import { AxiosInstance } from "axios"
import { CreateUpdateDepartment, Department } from "./departmentsTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum CompanyAdminDepartmentsQuery {
    LIST = "departments-for-company",
    DETAILS = "department-details",
}

type DepartmentsForCompanyParams = Readonly<{
    companyId: number
}>

export type DepartmentsForCompanyResponse = Readonly<{
    departments: Department[]
}>

export async function fetchDepartmentsForCompany(
    params: DepartmentsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DepartmentsForCompanyResponse> {
    const url = `/companies/${params.companyId}/departments`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

type DepartmentForCompanyParams = Readonly<{
    departmentId: string
}>

export type DepartmentForCompanyResponse = Readonly<{
    department: Department
}>

export async function fetchDepartmentForCompany(
    params: DepartmentForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DepartmentForCompanyResponse> {
    const url = `/departments/${params.departmentId}`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

export async function createDepartmentForCompany(
    { department, companyId }: { department: CreateUpdateDepartment; companyId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/departments`,
        {
            department: {
                ...department,
                company: {
                    id: companyId,
                },
            },
        },
        {
            signal,
        },
    )
    return data
}

export async function updateDepartmentForCompany(
    { department, departmentId }: { department: CreateUpdateDepartment; departmentId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/departments/${departmentId}`,
        {
            department,
        },
        {
            signal,
        },
    )
    return data
}

type DeleteDepartmentForCompanyParams = Readonly<{
    departmentId: number
}>

export async function deleteDepartmentForCompany(
    { departmentId }: DeleteDepartmentForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/departments/${departmentId}`, {
        signal,
    })
    return data
}
